import { Controller } from "@hotwired/stimulus"

// Shows a live "N / max" character count below a textarea or input.
// Usage:
//   <div data-controller="char-counter" data-char-counter-max-value="200">
//     <textarea data-char-counter-target="input" data-action="input->char-counter#update"></textarea>
//     <span data-char-counter-target="count"></span>
//   </div>
export default class extends Controller {
  static targets = ["input", "count"]
  static values  = { max: Number }

  connect() {
    this.update()
  }

  update() {
    const len = this.inputTarget.value.length
    const max = this.maxValue
    this.countTarget.textContent = `${len} / ${max}`

    // Warn when over 90 % of the limit
    const nearLimit = len >= Math.floor(max * 0.9)
    this.countTarget.classList.toggle("text-warning-600", nearLimit && len <= max)
    this.countTarget.classList.toggle("text-error-600",   len > max)
    this.countTarget.classList.toggle("text-gray-400",    !nearLimit && len <= max)
  }
}
